import React from 'react';
import { connect } from 'react-redux';
import { AddWhite, RequestHistoryIcon } from '../../../assets/icons';
import { DigitalCard as DigitalCardImg, Service1 } from '../../../assets/img';
import { Link } from 'react-router-dom';

class Requests extends React.Component {

  getDottedName = () => {
    let names = String(this.props.user?.name).trim().split(' ');
    let lastnames = String(this.props.user?.last_name).trim().split(' ');

    if (names.length > 1) {
      const lastIdx = names.length - 1;
      names[lastIdx] = names[lastIdx].substring(0,1) + '.';
    }
    names = names.join(' ');

    if (lastnames.length > 1) {
      const lastIdx = lastnames.length - 1;
      lastnames[lastIdx] = lastnames[lastIdx].substring(0,1) + '.';
    }
    lastnames = lastnames.join(' ');

    return `${names} ${lastnames}`;
  }

	render() {
		return (
      <div className="-mt-4 -mx-4 mb-8">
        <div className="relative h-[300px] flex justify-center items-center">
          <img src={Service1} className="object-cover w-full h-[300px] absolute" alt="" />
          <div className="flex justify-center relative left-0 right-0 my-auto">
            <img src={DigitalCardImg} className="h-[200px] object-contain" alt="" />
            <p className="text-white text-lg font-semibold mb-2 absolute bottom-1 left-12">
              { this.getDottedName() }
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 mb-5">
          <Link
            to="/historial/servicios"
            className="bg-white rounded-lg overflow-hidden flex items-center gap-3 p-2 border border-gray6 w-72"
          >
            <div className="w-10 h-10 rounded-lg bg-darkBlue flex justify-center items-center">
              <img src={RequestHistoryIcon} className="w-6 h-6 object-contain" alt="" />
            </div>
            <p className="font-bold text-text">Historial de Servicios</p>
          </Link>

          <Link
            to="/servicios/solicitar"
            className="bg-white rounded-lg overflow-hidden flex items-center gap-3 p-2 border border-gray6 w-72"
          >
            <div className="w-10 h-10 rounded-lg bg-green flex justify-center items-center">
              <img src={AddWhite} className="w-6 h-6 object-contain" alt="" />
            </div>
            <p className="font-bold text-text">Solicitar servicio</p>
          </Link>
        </div>
      </div>
		)
	}
}

export default connect(state => ({
  user: state.user,
}))(Requests);